// ADR-0163 — los errores de convertir una consulta, traducidos a algo que
// el jefe pueda accionar. Los ejes que faltan viajan como CÓDIGOS
// (`CONVERSION_EJES`); las etiquetas salen de `CONVERSION_EJE_LABEL`.

import {
  CONVERSION_CLASSIFICATION_INCOMPLETE,
  CONVERSION_EJE_LABEL,
  CONVERSION_EJES,
  CONVERSION_SPECIALTY_NOT_ALLOWED,
  INQUIRY_AUTHOR_NOT_CURRENT_OWNER,
  OWNER_INQUIRY_ALREADY_CONVERTED,
  type ConversionEje,
} from "@bitacorapro/api-types";
import { ApiError } from "./error";

const isEje = (v: unknown): v is ConversionEje =>
  typeof v === "string" && (CONVERSION_EJES as readonly string[]).includes(v);

/** Los ejes que faltan (en es-CL), o null si el error no es ese 422. */
export function conversionEjesMissing(err: unknown): string[] | null {
  if (!(err instanceof ApiError)) return null;
  if (err.status !== 422 || err.code !== CONVERSION_CLASSIFICATION_INCOMPLETE) return null;
  const raw = err.details?.["ejes"];
  if (!Array.isArray(raw)) return [];
  return raw.filter(isEje).map((code) => CONVERSION_EJE_LABEL[code]);
}

/** El texto propio de cada rechazo de la conversión, o null (el caller
 *  cae a su mensaje genérico). */
export function conversionErrorText(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  if (err.code === OWNER_INQUIRY_ALREADY_CONVERTED) {
    return "Alguien ya convirtió esta consulta en observación.";
  }
  if (err.code === INQUIRY_AUTHOR_NOT_CURRENT_OWNER) {
    return "La unidad cambió de propietario; esta consulta ya no se puede convertir.";
  }
  if (err.code === "ASSET_NOT_ACTIVATED") {
    return "La unidad no está activada: no se pueden registrar observaciones en ella.";
  }
  if (err.code === CONVERSION_SPECIALTY_NOT_ALLOWED) {
    return "No se puede convertir con la especialidad «Otro»: elige el tipo de reparación.";
  }
  if (err.code === "INVARIANT_VIOLATION") {
    return "La clasificación no calza con el catálogo (revisa el recinto: tiene que ser de la unidad).";
  }
  return null;
}
